import * as React from 'react';
import * as ReactDOM from 'react-dom';

import {Layout, default as ProgressTask} from "./ProgressTask";
import ProgressDialog from "./ProgressDialog";
import {Status} from "./ProgressStatus";

let dialogContainer: HTMLDivElement;

interface DialogOptions {
    title?: string;
    description?: string;
    image?: string;
    imageHeight?: number;
}

/**
 * To open the ProgressDialog
 *
 * @param tasksArray: any[]
 * @example  [{identifier: "task_name", title: "TaskTitle"}, {identifier: "task_name2", title: "TaskTitle2"},]
 * @param options:    DialogOptions
 */
export function showDialog(tasksArray: any[], options: DialogOptions) {
    dialogContainer = document.createElement('div');

    let dialogTasks: JSX.Element[] = [];
    let registeredDialogTasks: string[] = [];

    tasksArray.reverse().forEach((task, key) => {
        dialogTasks.splice(0, 0, <ProgressTask
                identifier={task.identifier}
                title={task.title}
                state={Status.WAITING}
                followedBy={registeredDialogTasks.slice()}
                key={key}
                index={tasksArray.length - key}
                layout={Layout.STEPS}
            />
        );
        registeredDialogTasks.push(task.identifier);
    });

    ReactDOM.render(
        <ProgressDialog title={options.title}
                        description={options.description}
                        image={options.image}
                        imageHeight={options.imageHeight}
                        tasks={dialogTasks}
                        open={true}
        />,
        dialogContainer
    );

    document.body.appendChild(dialogContainer);
}

export function hideDialog() {
    ReactDOM.unmountComponentAtNode(
        dialogContainer
    );
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/progress-dialog/ProgressDialogApi.tsx
 **/